import { ReactNode } from 'react';
import {
  StepLabel as MUIStepLabel,
  StepLabelProps as MUIStepLabelProps,
} from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
  error?: boolean;
};

export type StepLabelProps = AtomMUIProps;

export const StepLabel = (props: StepLabelProps) => {
  const MUIProps: MUIStepLabelProps = props;

  return <MUIStepLabel {...MUIProps} />;
};

export default StepLabel;
